(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["met-grown-files-gallery"] && !Shopify.designMode) return;
  try {
    import('@shopify/events').then(({ StandardEvents }) => {







    class MetGrownFilesGallery extends HTMLElement {







      #section;







      #sequence = 0;







      #index = 0;















      connectedCallback() {







        this.#section = this.closest('.shopify-section, dialog');







        this.#section?.addEventListener(StandardEvents.productSelect, this.#onSelect);







        this.addEventListener('click', this.#onClick);







        this.addEventListener('keydown', this.#onKeydown);







      }















      disconnectedCallback() {







        this.#section?.removeEventListener(StandardEvents.productSelect, this.#onSelect);







        this.removeEventListener('click', this.#onClick);







        this.removeEventListener('keydown', this.#onKeydown);







        this.#section = undefined;







        this.#sequence += 1;







      }















      #stopVideos() {







        this.querySelectorAll('[data-grown-video-frame] video').forEach((video) => video.pause());







        this.querySelectorAll('[data-grown-video-frame]').forEach((frame) => frame.replaceChildren());







        this.querySelectorAll('[data-grown-play]').forEach((button) => { button.hidden = false; });







      }















      #show(index, focus = false) {







        const panels = Array.from(this.querySelectorAll('[data-grown-panel]'));







        const thumbnails = Array.from(this.querySelectorAll('[data-grown-thumbnail]'));







        if (!panels.length) return;







        this.#stopVideos();







        this.#index = Math.max(0, Math.min(index, panels.length - 1));







        panels.forEach((panel, i) => { panel.hidden = i !== this.#index; });







        thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.#index)));







        const previous = this.querySelector('[data-grown-previous]');







        const next = this.querySelector('[data-grown-next]');







        if (previous) previous.disabled = this.#index === 0;







        if (next) next.disabled = this.#index === panels.length - 1;







        if (focus) thumbnails[this.#index]?.focus();







      }















      #onClick = (event) => {







        if (!(event.target instanceof Element)) return;







        const button = event.target.closest('button');







        if (!button || !this.contains(button)) return;







        if (button.hasAttribute('data-grown-thumbnail')) this.#show(Number(button.dataset.grownThumbnail));







        if (button.hasAttribute('data-grown-previous')) this.#show(this.#index - 1);







        if (button.hasAttribute('data-grown-next')) this.#show(this.#index + 1);







        if (button.hasAttribute('data-grown-play')) {







          const video = button.closest('[data-grown-video]');







          const template = video?.querySelector('[data-grown-video-template]');







          const frame = video?.querySelector('[data-grown-video-frame]');







          if (template && frame) {







            frame.replaceChildren(template.content.cloneNode(true));







            button.hidden = true;







            const hostedVideo = frame.querySelector('video');







            if (hostedVideo) {







              hostedVideo.muted = true;







              hostedVideo.play().catch(() => { hostedVideo.controls = true; });







            }







          }







        }







        const dialog = this.querySelector('[data-grown-zoom-dialog]');







        if (button.hasAttribute('data-grown-zoom-url') && dialog) {







          const image = dialog.querySelector('[data-grown-zoom-image]');







          image.src = button.dataset.grownZoomUrl;







          image.alt = button.dataset.grownZoomAlt || '';







          dialog.showModal();







        }







        if (button.hasAttribute('data-grown-close-zoom')) dialog?.close();







      };















      #onKeydown = (event) => {







        if (!(event.target instanceof Element) || !event.target.closest('[data-grown-thumbnail]')) return;







        const length = this.querySelectorAll('[data-grown-panel]').length;







        let index;







        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index = this.#index + 1;







        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index = this.#index - 1;







        if (event.key === 'Home') index = 0;







        if (event.key === 'End') index = length - 1;







        if (index === undefined) return;







        event.preventDefault();







        this.#show(index, true);







      };















      #unavailable(label = this.dataset.unavailableLabel || '') {







        this.querySelector('[data-grown-zoom-dialog]')?.close();







        const content = this.querySelector('[data-grown-gallery-content]');







        content?.replaceChildren();







        if (content) content.hidden = true;







        const status = this.querySelector('[data-grown-gallery-status]');







        if (status) { status.textContent = label; status.hidden = false; }







        this.dataset.galleryValid = 'false';







        this.dataset.variantId = '';







        this.removeAttribute('aria-busy');







      }















      #onSelect = (event) => {







        if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;







        const picker = event.target.closest('variant-picker');







        if (!picker || picker.dataset.productId !== this.dataset.productId) return;







        const owner = this.closest('product-component');







        if (owner && event.target.closest('product-component') !== owner) return;







        const sequence = ++this.#sequence;







        this.#unavailable(this.dataset.loadingLabel || '');







        this.setAttribute('aria-busy', 'true');







        event.promise.then(({ detail }) => {







          if (!this.isConnected || sequence !== this.#sequence) return;







          if (!detail?.html || String(detail.productId) !== this.dataset.productId || !detail.resource?.id) {







            this.#unavailable();







            return;







          }







          const incoming = Array.from(detail.html.querySelectorAll('met-grown-files-gallery')).find((element) =>







            element.dataset.blockId === this.dataset.blockId && element.dataset.productId === this.dataset.productId







          );







          if (!incoming || incoming.dataset.galleryValid !== 'true' || incoming.dataset.variantId !== String(detail.resource.id)) {







            this.#unavailable();







            return;







          }







          const nextContent = incoming.querySelector('[data-grown-gallery-content]');







          const currentContent = this.querySelector('[data-grown-gallery-content]');







          if (!nextContent || !currentContent) { this.#unavailable(); return; }







          currentContent.replaceWith(nextContent.cloneNode(true));







          this.dataset.variantId = incoming.dataset.variantId;







          this.dataset.galleryValid = 'true';







          this.#index = 0;







          const status = this.querySelector('[data-grown-gallery-status]');







          if (status) { status.textContent = ''; status.hidden = true; }







          this.removeAttribute('aria-busy');







        }).catch(() => {







          if (this.isConnected && sequence === this.#sequence) this.#unavailable();







        });







      };







    }















    if (!customElements.get('met-grown-files-gallery')) customElements.define('met-grown-files-gallery', MetGrownFilesGallery);







  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["met-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('met-product-share')) {
    customElements.define('met-product-share', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.trigger = this.querySelector('.met-share__trigger');
        this.panel = this.querySelector('.met-share__panel');
        this.input = this.querySelector('.met-share__url');
        this.status = this.querySelector('.met-share__status');
        const options = { signal: this.controller.signal };
        this.trigger.hidden = false;
        this.trigger.addEventListener('click', () => this.share(), options);
        this.querySelector('.met-share__copy').addEventListener('click', () => this.copy(), options);
        this.querySelector('.met-share__whatsapp').addEventListener('click', () => this.updateLinks(), options);
        this.input.addEventListener('click', () => this.input.select(), options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.panel.hidden) {
            event.preventDefault();
            this.close();
            this.trigger.focus();
          }
        }, options);
      }

      disconnectedCallback() { this.controller?.abort(); }

      getUrl() {
        const url = new URL(this.dataset.url, location.origin);
        const current = new URL(location.href);
        if (current.pathname.endsWith(url.pathname)) url.pathname = current.pathname;
        const scope = this.closest('.product-details, met-eternity, met-aureline-product, .met-first-light') || this.closest('.shopify-section');
        const variantInput = scope?.querySelector('form[action*="/cart/add"] input[name="id"]:checked, form[action*="/cart/add"] input[name="id"]:not([type="radio"]), form[action*="/cart/add"] select[name="id"]');
        const variant = variantInput ? variantInput.value : new URL(location.href).searchParams.get('variant');
        url.search = '';
        url.hash = '';
        if (/^\d+$/.test(variant || '')) url.searchParams.set('variant', variant);
        return url.href;
      }

      updateLinks() {
        const url = this.getUrl();
        this.input.value = url;
        this.querySelector('.met-share__whatsapp').href = 'https://wa.me/?text=' + encodeURIComponent(this.dataset.title + '\n' + url);
        return url;
      }

      close() {
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      async share() {
        if (this.busy) return;
        if (!this.panel.hidden) { this.close(); return; }
        const data = { title: this.dataset.title, url: this.updateLinks() };
        if (typeof navigator.share === 'function') {
          this.busy = true;
          try {
            await navigator.share(data);
            return;
          } catch (error) {
            if (error.name === 'AbortError') return;
          } finally { this.busy = false; }
        }
        this.status.textContent = '';
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.input.focus();
        this.input.select();
      }

      async copy() {
        const url = this.updateLinks();
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(url);
          this.status.textContent = this.dataset.copied;
        } catch {
          this.input.focus();
          this.input.select();
          this.status.textContent = this.dataset.copyError;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["met-turkey-currency-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('met-currency-notice')) {
    customElements.define('met-currency-notice', class extends HTMLElement {
      connectedCallback() {
        this.updateCurrency = (event) => {
          const selected = typeof event?.detail === 'string'
            ? event.detail
            : document.querySelector('.bucks-selected')?.textContent?.trim()
              || document.querySelector('[bucks-currency]')?.getAttribute('bucks-currency');
          this.hidden = selected !== 'TRY';
        };
        document.addEventListener('BUCKS_SELECTED_CURRENCY', this.updateCurrency);
        this.currencyObserver = new MutationObserver(() => this.updateCurrency());
        this.currencyObserver.observe(document.body, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['bucks-currency']
        });
        this.updateCurrency();
      }
      disconnectedCallback() {
        document.removeEventListener('BUCKS_SELECTED_CURRENCY', this.updateCurrency);
        this.currencyObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('met-gallery-video')) {







  customElements.define('met-gallery-video', class extends HTMLElement {







    connectedCallback() {







      const slide = this.closest('slideshow-slide');







      if (!slide) return;







      this.observer = new MutationObserver(() => {







        if (slide.getAttribute('aria-hidden') === 'true') this.querySelector('video')?.pause();







      });







      this.observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });







    }







    disconnectedCallback() {







      this.observer?.disconnect();







      this.querySelector('video')?.pause();







    }







  });







}
  } catch(e) { console.error(e); }
})();

})();
